import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronUp = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.293 9.29289C11.6835 8.90237 12.3167 8.90237 12.7072 9.29289L16.7072 13.2929L15.293 14.7071L12.0001 11.4142L8.70718 14.7071L7.29297 13.2929L11.293 9.29289Z"
        />
      </svg>
    );
  }
);
